import CONFIG from 'config';
import RCSLoggerFactory from 'rcs_logger';

export const gptLogger = RCSLoggerFactory.init('[GPT]', {
    level: CONFIG.build.env === 'prod' && !location.href.includes('gptLogs=true') ? 'error' : 'debug',
});

export const gptExtensionsLogger = RCSLoggerFactory.init('[GPT EXTENSIONS]', {
    level: CONFIG.build.env === 'prod' && !location.href.includes('gptLogs=true') ? 'error' : 'debug',
});

export const gptControllersLogger = RCSLoggerFactory.init('[GPT EXTENSIONS]', {
    level: CONFIG.build.env === 'prod' && !location.href.includes('gptLogs=true') ? 'error' : 'debug',
});
